<template>
  <popup
    :opened="dataToShow"
    @close="close"
  >
    <!-- BEGIN STEP 1 : Content modal add new file -->
    <div
      v-if="step == 1"
      v-cloak
      @drop.prevent="addTempFile"
      @dragover.prevent
    >
      <div class="my-5 mx-5 lg:mx-20 xl:my-15 xl:mx-40 2xl:my-20 2xl:mx-32">
        <h3 class="mb-10">
          Ajouter un média
        </h3>
        <div class="bg-indigo-100 rounded-lg flex flex-col items-center space-y-3 p-10 lg:px-0 py-24">
          <icon
            name="file"
            class="hidden lg:block text-pink-600 w-12 h-12"
            :class="{'animate-pulse' : addNewFileLoading}"
          />
          <div
            v-if="!addNewFileLoading"
            class="flex flex-col items-center space-y-3"
          >
            <h3 class="hidden lg:block text-indigo-600">
              Glissez & Déposez
            </h3>
            <h6 class="hidden lg:block text-gray-600">
              ou <input
                type="file"
                id="upload-file"
                class="hidden"
                @change="addTempFile"
              ><label
                for="upload-file"
                class="underline cursor-pointer"
              >sélectionnez</label> votre média
            </h6>
                            
            <div class="lg:hidden">
              <input
                type="file"
                id="upload-file"
                class="hidden"
                @change="addTempFile"
              >
              <label for="upload-file">
                <action-button 
                  border-color="border-indigo-600"
                  text-color="text-white"
                  bg-color="bg-indigo-600"
                  icon-color="text-white"
                  bg-color-square="bg-indigo-600"
                  libelle="Sélectionner un média"
                  icon="file-add"
                  type-shadow="shadow-indigo"
                  :uppercase="true"
                />
              </label>
            </div>
            <div class="text-red-500 text-sm">
              {{ ((errors || []).file || [])[0] }}
            </div>
            <div class="text-red-500 text-sm">
              {{ ((errors || []).forbidden || [])[0] }}
            </div>
            <div class="text-red-500 text-sm">
              {{ ((errors || []).media || [])[0] }}
            </div>
          </div>
          <div v-if="addNewFileLoading">
            <h6 class="text-gray-600 animate-pulse">
              Fichier en cours d'envoi...
            </h6>
          </div>
        </div>
      </div>
    </div>
    <!-- END STEP 1 : Content modal add file -->

    <!-- BEGIN STEP 2 : edit new file informations -->
    <div v-else-if="step == 2">
      <h3 class="my-16 text-pink-600">
        Média ajouté
      </h3>
            
      <div class="flex flex-col lg:flex-row mx-5 xl:mx-15 mt-5 lg:mt-0 mb-5 gap-y-5 lg:gap-x-15 items-center">
        <div class="flex flex-col">
          <img 
            v-if="fileTemp.id !== ''" 
            class="object-fill rounded-lg h-64" 
            :src="mode === 'new' || fileTemp.tempPath ? '/'+fileTemp.tempPath : '/portfolio/'+infosPass.id_pass+'/'+fileTemp.filename" 
          >
          <div
            class="text-indigo-600 cursor-pointer italic text-base text-center font-medium"
            @click="step = 1;"
            @click.stop
          >
            Changer d'image
          </div>
        </div>
        <div class="grid grid-cols-6 items-center gap-x-10 gap-y-4 w-full">
          <div class="col-span-full lg:col-span-2">
            Nom :
          </div>
          <input-text
            class="lg:col-span-4"
            name="nom"
            :value="fileTemp.name" 
            @input="(newValue) => {fileTemp.name = newValue}"
            libelle=""
            :error="true"
            :msg-error="((errors || {}).name || [])[0]"
          />
                    
          <div class="col-span-full lg:col-span-2">
            Description :
          </div>
          <input-text-area 
            class="lg:col-span-4"
            name="description"
            :value="fileTemp.description" 
            @input="(newValue) => {fileTemp.description = newValue}"
            libelle=""
          />

          <div class="col-span-full lg:col-span-2">
            Catégorie :
          </div>
          <multiple-select 
            class="lg:col-span-4"
            name="categories"
            :datas="categories.map(cat => ({value: cat}))"
            :left="false"
            :value="fileTemp.categories" 
            @input="(newValue) => {fileTemp.categories = newValue}"
            libelle=""
            :adddata="true"
            :msg-error="errorCategories"
            :error="true"
            :max-length-new-libelle="26"
            @errorMaxLengthNewLibelle="(msg) => {errorCategories = msg}"
          />
        </div>
      </div>
      <div class="text-red-500 text-sm my-10">
        {{ ((errors || []).forbidden || [])[0] }}
      </div>
      <div class="flex w-full justify-center my-15">
        <action-button 
          v-if="mode === 'new'"
          border-color="border-pink-600"
          text-color="text-white"
          bg-color="bg-pink-600"
          icon-color="text-white"
          bg-color-square="bg-pink-600"
          libelle="Continuer"
          icon="arrow-right_1"
          :right="true"
          :spinner="false"
          type-shadow="shadow-pink"
          :uppercase="true"
          @clickAction="uploadFile"
        />

        <action-button 
          v-if="mode === 'edit'"
          border-color="border-pink-600"
          text-color="text-white"
          bg-color="bg-pink-600"
          icon-color="text-white"
          bg-color-square="bg-pink-600"
          libelle="Modifier"
          icon="edit"
          :right="true"
          :spinner="false"
          type-shadow="shadow-pink"
          :uppercase="true"
          @clickAction="editFile"
        />
      </div>
    </div>
    <!-- END STEP 2 : edit new file informations -->
  </popup>
</template>

<script>
import { mapGetters } from 'vuex';

import Popup from './../Popup';
import Icon from './../Icon';
import Illustration from './../Illustration';
import ActionButton from './../ActionButton';
import InputText from './../Inputs/InputText';
import InputTextArea from '../Inputs/InputTextArea.vue';
import MultipleSelect from '../Inputs/MultipleSelect.vue';
import InputSelect from '../Inputs/InputSelect.vue';
import Constants from './../../constants';

import axios from './../../api';

export default {
  name:'MediaManagerPopup',

  components:{
    Popup,
    Icon,
    Illustration,
    ActionButton,
    InputText,
    InputTextArea,
    MultipleSelect,
    InputSelect
  },

  props:{
    dataToShow: {
      type: Boolean,
      required: false,
      default: false,
    },
    currentFolder:{
      type: Number,
      required:false,
      default: null
    },
    categories:{
      type: Array,
      required: false,
      default: [],
    }
  },

  data() {
    return {
      step: 1,
      mode: 'new',
      addNewFileLoading: false,
      fileTemp:{
        tempPath: '',
        filename: '',
        name: '',
        description: '',
        categories: [],
      },
      constants: Constants,
      tooMuchFiles:false,
      file:null,
      errors:{},
      errorCategories:'',
    };
  },


  computed:{
    ...mapGetters({
      infosPass: 'neopass/infosPass',
      user: 'auth/user',
    }),
  },

  methods:{
    close(){
      this.step = 1;
      this.addNewFileLoading = false;
      this.fileTemp = {
        id:0,
        tempPath: '',
        filename: '',
        extension: '',
        name: '',
        description: '',
        categories: [],
      };
      this.mode = 'new';
      this.errorCategories='';
      this.errors = {};

      this.$emit('close');
    },

    async addTempFile(e){
      const idUser = this.infosPass.id_pass;

      if(!this.$can(Constants.PERMISSION_NEOPASS_FORM_PORTFOLIO_EDITER, idUser)){
        this.errors.forbidden = ['Vous n\'êtes pas autorisé à ajouter un fichier dans ce dossier.'];
        return;
      }

      let files = e.target.files || e.dataTransfer.files;

      if(files.length == 1){
        //Store the file locally
        this.file = files[0];

        //Creating the request object
        let formData = new FormData();
        formData.append('media', this.file);
                
        this.addNewFileLoading = true;

        await axios.post('api/portfolio/temp', formData).then((response) => {
          if(this.mode === 'new'){
            this.fileTemp.tempPath = response.data;
            this.fileTemp.name = this.file.name;
            this.fileTemp.filename = this.file.name.substring(0, this.file.name.lastIndexOf('.'));
            this.fileTemp.extension = this.file.name.substring(this.file.name.lastIndexOf('.'));
          }
                    
          if(this.mode === 'edit'){
            this.fileTemp.tempPath = response.data;
            this.fileTemp.extension = this.file.name.substring(this.file.name.lastIndexOf('.'));
          }

          this.step = 2;
          this.addNewFileLoading = false;
        }).catch(err => {
          console.log('ERR::', err);
          if(err.response.status === 422){
            console.log(err.response.data.errors);
            this.errors = err.response.data.errors;
          }
          this.addNewFileLoading = false;
        });
      }
    },

    async uploadFile(){
      const idUser = this.infosPass.id_pass;

      if(!this.$can(Constants.PERMISSION_NEOPASS_FORM_PORTFOLIO_EDITER, idUser)){
        this.step=1;
        this.errors.forbidden = ['Vous n\'êtes pas autorisé à ajouter un fichier dans ce dossier.'];
        return;
      }

      await axios.put('api/portfolio/add/'+idUser, this.fileTemp).then((response) => {
        this.$emit('newMedia');
        this.close();
      }).catch(err => {
        if(err.response.status === 403){
          this.step=1;
          this.errors.forbidden = ['Vous n\'êtes pas autorisé à ajouter un fichier dans ce dossier.'];
        }
        if(err.response.data.errors.categories){
          this.errorCategories = err.response.data.errors.categories[0];
        }
        this.errors = err.response.data.errors;
      });
    },

    async editFile(){
      const idUser = this.infosPass.id_pass;

      if(!this.$can(Constants.PERMISSION_NEOPASS_FORM_PORTFOLIO_EDITER, idUser)){
        this.errors.forbidden = ['Vous n\'êtes pas autorisé à modifier un media.'];
        return;
      }

      await axios.put('api/portfolio/edit/'+idUser, this.fileTemp).then((response) => {
        this.$emit('newMedia');
        this.close();
      }).catch(err => {
        if(err.response.status === 403){
          this.errors.forbidden = ['Vous n\'êtes pas autorisé à modifier un média.'];
        }
        if(err.response.data.errors.categories){
          this.errorCategories = err.response.data.errors.categories[0];
        }
        this.errors = err.response.data.errors;
      });
    }
  }
};
</script>